import { Divider, Layout } from "ant-design-vue";
import { Component, Vue } from "vue-property-decorator";
import VcHeaderMenu from "@/components/layout/header-menu/header-menu.vue";
import { ImpersonationLocale } from "@/locales/localeid";
import { fmtMsg, GLGlobal, GLUtil } from "commonui";

const { Header } = Layout;

@Component({
	components: {
		Header,
		VcHeaderMenu,
		Divider
	}
})
export default class VcHeader extends Vue {
	schoolUrl = process.env.VUE_APP_SCHOOL_PORTAL_URL;
	public code = GLUtil.getImpersonationSwitchBackCode();
	get isImpersonating() {
		return GLUtil.isImpersonating();
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	switchBack = () => {
		if (!this.code) {
			return "";
		}
		location.href =
			GLGlobal.authorityUrl() +
			"/Impersonation/SwitchBack?code=" +
			this.code.switchBackCode +
			"&uid=" +
			this.code.impersonatedByUserId;
	};

	get impersonationLocale() {
		return ImpersonationLocale;
	}
}
